import React from 'react';

interface GripMouseProps {}

export function GripMouse(props: Readonly<GripMouseProps>) {
	return (
		<svg width={91} height={55} viewBox="0 0 91 55" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_18900)">
				<path d="M72.001 44h-30s-1.306-16.5 15-16.5c16.307 0 15 16.5 15 16.5z" fill="#445662" />
				<path
					fill="#999"
					d="M58.684 13.92c1.323.61 4.038 4.031 6.558 8.314 2.456 6.802.618 6.748 0 6.802-1.7 0-3.11-.918-3.905-1.952-.63-.819-.882-1.7-1.512-2.897-.63-.567-2.449-2.839-3.59-3.527-1.511 0-6.592 3.275-7.558 3.904-1.069.698-3.199 3.245-4.101 4.666-1.41 2.22-.299 4.408-.299 4.408 5.597 2.075 11.966.374 13.974.563 2.008.189 5.164 1.386 5.164 3.527 0 1.89-1.763 3.464-5.353 3.464-3.212 0-7.747-.567-9.952-.378-2.204-.252-10.644 1.953-16.06 1.953-4.164 0-8.503-1.512-10.33-2.646 0 0-1.855-1.23-3.086-2.519 0 0-1.008-1.512-1.197-3.023-.189-1.512.756-3.464.756-3.464.529-.943 2.079-2.52 3.527-3.59 1.449-1.07 5.067-2.233 5.284-2.263 0 0 2.558-.459 5.794-2.079 1.962-.691 5.29-3.338 5.29-3.338 1.272-1.281 1.765-1.772 2.394-2.078.63-.306 2.136-.504 3.795-.504 1.659 0 3.215-1.014 5.223-1.762s7.861-2.191 9.184-1.58z"
				/>
				<path
					fill="#999"
					d="M33.987 27.389c1.042 1.75 1.312 3.421 1.077 5.508-.234 2.087-1.005 4.407-2.33 5.623-.917.843-2.644 1.836-4.16 2.424-3.388 1.315-9.067 1.287-11.267 1-26.203-3.422-24.265-3.847-33.363-5.29-15.164-2.404-32.343-5.729-34.474-6.698-2.132-.97-5.595-3.594-6.708-4.943-1.112-1.35-3.83-5.068-3.707-8.239.123-3.17 1.045-5.614 2.69-8.313 1.644-2.7 4.189-4.016 6.078-4.492 2.268-.571 5.939-.218 8.705.216 8.763 1.502 17.218 4.114 25.763 7.417 6.772 2.711 9.506 4.983 16.372 7.657a73.728 73.728 0 0023.964 4.437c1.929-.075 4.58.293 5.871.495 1.292.201 4.502 1.539 5.49 3.198z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_18900">
					<path fill="#fff" d="M0 0H91V55H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
